import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { IoMdRemoveCircleOutline } from "react-icons/io";
import { IoMdAddCircleOutline } from "react-icons/io";
const AddModelAndVariant = () => {
    const [manufacturers, setManufacturers] = useState([]);
    const [selectedManufacturer, setSelectedManufacturer] = useState('');
    const [model, setModel] = useState('');
    const [variant, setVariant] = useState('');
    const [variantsList, setVariantsList] = useState([]);

    useEffect(() => {
        const fetchManufacturers = async () => {
            try {
                const response = await axios.get('https://zoomautos.co.uk/api/make');
                setManufacturers(response.data);
            } catch (error) {
                console.error('Error fetching manufacturers:', error);
            }
        };
        fetchManufacturers();
    }, []);

    const handleAddModelAndVariant = async (e) => {
        e.preventDefault();
        if (!selectedManufacturer || !model || !variantsList.length) {
            alert('Please fill in all fields.');
            return;
        }

        try {
            console.log('Selected Manufacturer ID:', selectedManufacturer);
            await axios.put(`https://zoomautos.co.uk/api/make/${selectedManufacturer}`, {
                model,
                variants: variantsList,
            });
            alert('Model and variants added successfully!');
            setModel('');
            setVariant('');
            setVariantsList([]);
        } catch (error) {
            console.error('Error adding model and variants:', error);
            alert('Failed to add model and variants.');
        }
    };

    const handleAddVariant = () => {
        if (variant) {
            setVariantsList([...variantsList, variant]);
            setVariant('');
        }
    };

    return (
        <div>
            <h1>Add Model and Variants</h1>
            <form className='makeform-container' onSubmit={handleAddModelAndVariant}>
                <div>
                    <label htmlFor="manufacturer">Select Manufacturer:</label>
                    <select
                        id="manufacturer"
                        value={selectedManufacturer}
                        onChange={(e) => setSelectedManufacturer(e.target.value)}
                        required
                    >
                        <option value="">-- Select Manufacturer --</option>
                        {manufacturers.map((manufacturer) => (
                            <option key={manufacturer._id} value={manufacturer._id}>
                                {manufacturer.manufacturer}
                            </option>
                        ))}
                    </select>
                </div>
                <div>
                    <label htmlFor="model">Model:</label>
                    <input
                        type="text"
                        id="model"
                        value={model}
                        onChange={(e) => setModel(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label htmlFor="variant">Variant:</label>
                    <input
                        type="text"
                        id="variant"
                        value={variant}
                        onChange={(e) => setVariant(e.target.value)}
                    />
                    <button
              type="button"
              onClick={() => handleAddVariant()}
              className="addbut"
              style={{marginLeft:'320px'}}
            >
              <IoMdAddCircleOutline/>
            </button>
                </div>
                <div>
                    <h4>Variants:</h4>
                    <ul>
                        {variantsList.map((v, index) => (
                            <li key={index}>{v}</li>
                        ))}
                    </ul>
                </div>
                <button type="submit">Add Model and Variants</button>
            </form>
        </div>
    );
};

export default AddModelAndVariant;
